export default "__VITE_ASSET__9rlCHi51__"